export default class utils{
     static getVal(list,val){
        let name = ''
        list.forEach(item => {
            if(item.dict_value == val){
                name =  item.dict_label
            }
        });
        return name;
     }
     
     static  formatDateMytime(date) { 
        var date = new Date(date)
        var year = date.getFullYear(); 
        var month = date.getMonth() + 1; 
        var day = date.getDate(); 
        var hour = date.getHours(); 
        var minute = date.getMinutes(); 
        var second = date.getSeconds(); 
        return year + "-" + formatTen(month) + "-" + formatTen(day)+ " " +formatTen(hour)+ ":" +formatTen(minute)+ ":" +formatTen(second); 
    } 

     //日期时间相减
     static getMIns(start){
        let _currentTime = getNowFormatDate();  //当前时间
        let mins = TimeDifference(start,_currentTime);
        if(mins>30){
            return false
        }else{
            return true
        }
     }
    
     static  checkIDCard(idcode){
            // 加权因子
            var weight_factor = [7,9,10,5,8,4,2,1,6,3,7,9,10,5,8,4,2];
            // 校验码
            var check_code = ['1', '0', 'X' , '9', '8', '7', '6', '5', '4', '3', '2'];

            var code = idcode + "";
            var last = idcode[17];//最后一位

            var seventeen = code.substring(0,17);

            // ISO 7064:1983.MOD 11-2
            // 判断最后一位校验码是否正确
            var arr = seventeen.split("");
            var len = arr.length;
            var num = 0;
            for(var i = 0; i < len; i++){
                num = num + arr[i] * weight_factor[i];
            }
            
            // 获取余数
            var resisue = num%11;
            var last_no = check_code[resisue];

            // 格式的正则
            // 正则思路
            /*
            第一位不可能是0
            第二位到第六位可以是0-9
            第七位到第十位是年份，所以七八位为19或者20
            十一位和十二位是月份，这两位是01-12之间的数值
            十三位和十四位是日期，是从01-31之间的数值
            十五，十六，十七都是数字0-9
            十八位可能是数字0-9，也可能是X
            */
            var idcard_patter = /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/;

            // 判断格式是否正确
            var format = idcard_patter.test(idcode);

            // 返回验证结果，校验码和格式同时正确才算是合法的身份证号码
            return last === last_no && format ? true : false;
        }
     static compareTime(start,end){
        if(startTime && end){
          let startTime= new Date(Date.parse(start));
          let endTime=new Date(Date.parse(end));
          if(startTime > endTime){
            return 1;
          }else{
            return 2;
          }
        }else{
          return 3
        }
     }
     static bjDate(date, date1) {
        var date = new Date(date);
        var date1 = new Date(date1);
        if (date.getTime() - date1.getTime() < 0) {
            return '1';
        } else {
            return '2';
        }
    }
}
function checkTime(i) {
  if (i<10) {
     i="0"+i;
  }
  return i;
} 


function   getNowFormatDate() {
    var date = new Date();
    var hengGang = "-";
    var maoHao = ":";
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var curDate = date.getDate();
    var curHours = date.getHours();
    var curMinutes = date.getMinutes();
    var curSeconds = date.getSeconds();

    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (curDate >= 0 && curDate <= 9) {
      curDate = "0" + curDate;
    }
    if (curHours >= 0 && curHours <= 9) {
      curHours = "0" + curHours;
    }
    if (curMinutes >= 0 && curMinutes <= 9) {
      curMinutes = "0" + curMinutes;
    }
    if (curSeconds >= 0 && curSeconds <= 9) {
      curSeconds = "0" + curSeconds;
    }

    var currentdate = year + hengGang + month + hengGang + curDate + ' ' + curHours + maoHao + curMinutes + maoHao + curSeconds;
    return currentdate;
  }
  function TimeDifference(time1,time2)
  {      
        //定义两个变量time1,time2分别保存开始和结束时间
        // var time1="2009-12-02 12:25:25";
        // var time2="2009-12-03 12:35:25";
       //截取字符串，得到日期部分"2009-12-02",用split把字符串分隔成数组
        var begin1=time1.substr(0,10).split("-");
        var end1=time2.substr(0,10).split("-");
        
        //将拆分的数组重新组合，并实例成化新的日期对象
        var date1=new Date(begin1[1] + - + begin1[2] + - + begin1[0]);
        var date2=new Date(end1[1] + - + end1[2] + - + end1[0]);
        
        //得到两个日期之间的差值m，以分钟为单位
        //Math.abs(date2-date1)计算出以毫秒为单位的差值
        //Math.abs(date2-date1)/1000得到以秒为单位的差值
        //Math.abs(date2-date1)/1000/60得到以分钟为单位的差值
        var m=parseInt(Math.abs(date2-date1)/1000/60);
        
        //小时数和分钟数相加得到总的分钟数
        //time1.substr(11,2)截取字符串得到时间的小时数
        //parseInt(time1.substr(11,2))*60把小时数转化成为分钟
        var min1=parseInt(time1.substr(11,2))*60+parseInt(time1.substr(14,2));
        var min2=parseInt(time2.substr(11,2))*60+parseInt(time2.substr(14,2));
        
        //两个分钟数相减得到时间部分的差值，以分钟为单位
        var n=min2-min1;
        
        //将日期和时间两个部分计算出来的差值相加，即得到两个时间相减后的分钟数
        var minutes=m+n;
        return(minutes);
  }

  function formatTen(num) { 
    return num > 9 ? (num + "") : ("0" + num); 
 }
